import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, DatePicker, Form, Row, Select } from 'antd';
import { renderConditionalOptions } from '../../../../utilities/formHelpers';
import { searchSelectProps } from '../../constants';

const AnnouncementSearch = ({
  onReset,
  onFinish,
  form,
  initialValues,
  courseOffers,
  getCourseOffers,
  courses,
}) => {
  const renderOptions = (data, valueKey, labelKey) =>
    data.map((item) => (
      <Select.Option key={item[valueKey]} value={item[valueKey]}>
        {item[labelKey]}
      </Select.Option>
    ));

  return (
    <Form form={form} onFinish={onFinish} initialValues={initialValues}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Course Name" name="courseId">
            <Select
              {...searchSelectProps}
              onChange={getCourseOffers}
              allowClear
            >
              {renderOptions(courses, 'courseId', 'title')}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Course Offer Code" name="courseOfferCode">
            <Select {...searchSelectProps} allowClear>
              {renderOptions(courseOffers, 'code', 'code')}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={4}>
          <Form.Item label="Is Assigned" name="isAssigned">
            <Select allowClear>{renderConditionalOptions()}</Select>
          </Form.Item>
        </Col>

        <Col>
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: false, message: 'Please input start date!' }]}
          >
            <DatePicker showNow={false} style={{ width: '100%' }} allowClear />
          </Form.Item>
        </Col>

        <Col>
          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: false, message: 'Please input end date!' }]}
          >
            <DatePicker showNow={false} style={{ width: '100%' }} allowClear />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

AnnouncementSearch.propTypes = {
  onFinish: PropTypes.func,
  onReset: PropTypes.func,
  initialValues: PropTypes.object,
  form: PropTypes.any, //change
  courseOffers: PropTypes.arrayOf(
    PropTypes.shape({
      wave: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
    })
  ),
  getCourseOffers: PropTypes.func.isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape({})),
};

AnnouncementSearch.defaultProps = {
  courseOffers: [],
};

export default AnnouncementSearch;
